import React, { Component } from 'react';
import Sidebar from './Sidebar';
import { Container } from 'reactstrap';

class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <React.Fragment>
        <Sidebar />
        <Container>
          {this.props.children}
        </Container>
        <img className="imgLayout" alt="monta" src="./assets/images/iconMonta.png" />
      </React.Fragment>
     
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js